import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import API from "../lib/api";
import logger from "../lib/logger";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = checking; false = anonymous; object = authenticated
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await API.get("/auth/me");
      setUser(data);
    } catch (e) {
      // 401 while checking session is expected for anonymous visitors.
      if (e?.response && e.response.status !== 401) {
        logger.error("Auth check failed:", e);
      }
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = useCallback(async (email, password) => {
    const { data } = await API.post("/auth/login", { email, password });
    setUser(data);
    return data;
  }, []);

  const register = useCallback(async (payload) => {
    const { data } = await API.post("/auth/register", payload);
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try { await API.post("/auth/logout"); } catch (e) { logger.error("Logout API call failed:", e); }
    setUser(false);
  }, []);

  const value = useMemo(
    () => ({ user, setUser, login, register, logout, refresh }),
    [user, login, register, logout, refresh]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);

export function homePathFor(user) {
  if (!user) return "/";
  switch (user.role) {
    case "admin": return "/admin";
    case "staff": return "/staff";
    case "validator": return "/validator";
    default: return "/member";
  }
}
